import { Bookmark } from './Styles'

const ScrollBookmark = ({ id }) => {
  return <Bookmark id={id}>&nbsp;</Bookmark>
}

export default ScrollBookmark
